// Theme Manager for automatic day/night background switching
class ThemeManager {
  constructor() {
    this.checkInterval = null;
    this.init();
  }

  init() {
    // Set initial theme
    this.updateTheme();
    
    // Check for theme changes every minute
    this.checkInterval = setInterval(() => {
      this.updateTheme();
    }, 60000); // Check every minute
    
    // Also check when the page becomes visible (user returns to tab)
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        this.updateTheme();
      }
    });
  }

  updateTheme() {
    const currentHour = new Date().getHours();
    const isDaytime = currentHour >= 6 && currentHour < 18; // 6 AM to 6 PM
    
    const html = document.documentElement;
    const body = document.body;
    
    // Remove existing theme classes
    html.classList.remove('daytime', 'nighttime');
    body.classList.remove('daytime', 'nighttime');
    
    // Add appropriate theme class
    if (isDaytime) {
      html.classList.add('daytime');
      body.classList.add('daytime');
    } else {
      html.classList.add('nighttime');
      body.classList.add('nighttime');
    }
  }

  // Manual theme override (for testing or user preference)
  setTheme(theme) {
    const html = document.documentElement;
    const body = document.body;
    
    html.classList.remove('daytime', 'nighttime');
    body.classList.remove('daytime', 'nighttime');
    
    if (theme === 'daytime' || theme === 'nighttime') {
      html.classList.add(theme);
      body.classList.add(theme);
    }
  }

  // Get current theme
  getCurrentTheme() {
    const html = document.documentElement;
    if (html.classList.contains('daytime')) return 'daytime';
    if (html.classList.contains('nighttime')) return 'nighttime';
    return null;
  }

  // Cleanup
  destroy() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
  }
}

// Create and export theme manager instance
const themeManager = new ThemeManager();

export default themeManager;
